<template>
    <div
        ref="blogPostContent"
        class="post-content -mt-24 bg-white w-full relative flex flex-col h-full text-gray-700 phone:py-12 py-24"
        :class="{'drop-cap': dropCap}"
        v-html="blogPostContent"
    />
</template>

<script>
export default {
  props: {
    blogPostContent: {
      type: String,
      required: true,
    },
    dropCap: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mounted() {
    this.$refs.blogPostContent.querySelectorAll('.post-content p').forEach((p) => {
      // if there's no image, stop
      if (p.querySelector('img') === null) {
        return;
      }

      // if there's text, stop
      if (p.innerText.trim() !== '') {
        return;
      }

      // if it's a small image, stop
      if (p.querySelector('img').clientWidth < 600) {
        return;
      }

      // otherwise, mark the paragraph as img-only
      p.classList.add('img-only');
    });
  },

};
</script>

<style lang="scss">
    .post-content {
        /*DROP CAP LETTER ON THE FIRST PARAGRAPH*/
        &.drop-cap {
            p:first-child:first-letter {
                font-size: 3.5rem;
                line-height: 2.75rem;
                float: left;
                margin-top: .15rem;
                padding-right: .25rem;
            }
        }

        p:not(.img-only), h2, hr {
            @screen phone {
                @apply px-6 mb-2;
            }
            @apply px-12 mb-4;
        }

        blockquote {
            &:before {
                content: ',,';
                width: .5rem;
                height: .5rem;
                @screen phone {
                    @apply -ml-8 scale-110 top-6;
                }
                @apply text-gold-500 absolute top-8 -ml-16 tracking-tighter font-bold transform scale-150 rotate-180;
            }

            @screen phone {
                @apply text-gold-500 border-l border-gold-500 pl-4 pr-8 mt-8 mb-12 ml-12 ;
            }

            @apply font-light relative text-gold-500 text-2xl border-l border-gold-500  mt-12 mb-16 ml-32 pl-8 pr-12;
        }

        h2 {
            @scren phone {
                @apply mb-4 mt-6;
            }
            @apply text-gold-500 uppercase mb-4 font-bold mt-12;
        }

        img {
            @screen phone {
                @apply mb-2 mt-4;
            }
            @apply mb-4 mt-8;
        }

        p.img-only img {
            width: 100%!important;
        }

        .footer {
            @apply italic;
        }

        .gold {
            @apply text-gold-500 font-bold;
        }

        img.fr-fic {
            @apply mx-auto;
        }

        hr {
            @screen phone {
                @apply ml-6 mb-4;
                max-width: 160px;
            }

            @apply text-gold-500 ml-24 mb-8;
            max-width: 180px;
        }
    }

</style>
